import { GenericElementEvent } from '../../event/generic-element-event';

export class GenericTreeInitEvent extends GenericElementEvent {
    
}
